<template>
    <div class="isomere-alkohole">
        <ul>
            <li><b>Primär</b> (1-)Butanol</li>
            <li><b>Sekundär</b> 2-Butanol</li>
            <li><b>Tertiär</b> 2-Methyl-Propanol</li>
        </ul>
        <em>C<sub>4</sub>H<sub>9</sub>OH</em>
    </div>
</template>

<script>
export default {
    name: 'isomere-alkohole',
};
</script>
